import { FC, ReactElement } from "react";

const Send:FC =():ReactElement=>{
    return(
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <path d="M30.617 3.025c0.057-0.201 0.067-0.419 0.020-0.635-0.032-0.151-0.091-0.299-0.175-0.433-0.085-0.136-0.193-0.253-0.317-0.349-0.156-0.12-0.332-0.2-0.515-0.241s-0.376-0.045-0.568-0.005c-0.056 0.012-0.113 0.028-0.168 0.047l-0.028 0.009-26.64 9.324c-0.336 0.117-0.623 0.368-0.779 0.717-0.299 0.673 0.004 1.461 0.677 1.76l11.532 5.125 5.125 11.532c0.144 0.324 0.417 0.591 0.777 0.717 0.695 0.243 1.456-0.123 1.699-0.819l9.324-26.639c0.013-0.036 0.025-0.072 0.036-0.109zM14.372 15.743l-8.091-3.595 17.977-6.293zM26.145 7.741l-6.293 17.977-3.595-8.091z"></path>
        </svg>
    )
}

export default Send;